<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';

const props = defineProps({
  offer: { type: Object, required: true },
  buyerLabel: { type: String, default: '' },
});

const emit = defineEmits(['profile', 'chat']);

const initials = computed(() => {
  const name = props.buyerLabel || props.offer.contact_name || 'Cliente';
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part[0])
    .join('')
    .toUpperCase();
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section
    class="offer-details-header min-w-0 max-w-full rounded-lais border border-lais-primary/20 bg-lais-primary-50 p-4 sm:p-5"
  >
    <div class="offer-details-header__content min-w-0">
      <div class="offer-details-header__identity min-w-0">
        <span
          class="grid size-11 shrink-0 place-items-center rounded-full bg-white font-semibold text-lais-primary shadow-sm"
        >
          {{ initials }}
        </span>
        <div class="min-w-0 flex-1">
          <p
            class="text-[11px] font-semibold uppercase tracking-[0.14em] text-lais-text-muted"
          >
            Cliente
          </p>
          <h3
            class="mt-0.5 max-w-full break-words font-redHatDisplay text-lais-heading-sm font-semibold leading-snug text-lais-text sm:text-lais-heading-md"
          >
            {{ buyerLabel || 'Cliente não vinculado' }}
          </h3>
        </div>
      </div>
      <div class="offer-details-header__actions shrink-0">
        <button
          type="button"
          class="offer-details-header__action inline-flex min-h-10 items-center justify-center gap-2 whitespace-normal rounded-lais border border-white/80 bg-white px-3 text-center text-[12px] font-semibold text-lais-primary shadow-sm transition hover:bg-lais-bg-soft focus-visible:outline-none focus-visible:shadow-lais-focus"
          aria-label="Abrir perfil do cliente"
          @click="emit('profile', offer)"
        >
          <span class="i-lucide-user-round size-4" aria-hidden="true" />
          <span>Perfil</span>
        </button>
        <button
          type="button"
          class="offer-details-header__action inline-flex min-h-10 items-center justify-center gap-2 whitespace-normal rounded-lais border border-white/80 bg-white px-3 text-center text-[12px] font-semibold text-lais-primary shadow-sm transition hover:bg-lais-bg-soft focus-visible:outline-none focus-visible:shadow-lais-focus"
          aria-label="Abrir conversa com o cliente"
          @click="emit('chat', offer)"
        >
          <span class="i-lucide-message-circle size-4" aria-hidden="true" />
          <span>Conversar</span>
        </button>
      </div>
    </div>
  </section>
</template>

<style scoped>
.offer-details-header {
  container-type: inline-size;
}

.offer-details-header__content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.offer-details-header__identity {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.offer-details-header__actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.5rem;
}

@container (min-width: 22rem) {
  .offer-details-header__actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@container (min-width: 34rem) {
  .offer-details-header__content {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  .offer-details-header__identity {
    align-items: center;
  }

  .offer-details-header__actions {
    display: flex;
  }
}
</style>
